import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const AlertaIdentidad = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.$backgroundColor || '#fffbea'};
  border: 1px solid ${(props) => props.$borderColor || '#f6c343'};
  color: #000;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  max-width: fit-content;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;

export const AlertaIcono = styled.div`
  background-color: ${(props) => props.$backgroundColor || '#f6c343'};
  color: #000;
  border-radius: 50%;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  font-size: 14px;
`;

export const AlertaTexto = styled.span`
  line-height: 1.2;
  color: ${(props) => props.$textColor || colors.black};
`;
  
  